if (!window.customElements.get('featured-links')) {
  class FeaturedLinks extends HTMLElement { // eslint-disable-line
    constructor() {
      super()

      this.prev = this.querySelector('[data-prev]')
      this.next = this.querySelector('[data-next]')
      this.options = {
        slidesPerView: 'auto',
        threshold: 10,
        spaceBetween: 32,
        slidesPerGroup: 1,
        navigation: {
          nextEl: this.next,
          prevEl: this.prev
        }
      }

      this.dataset.enabled === 'true' && this.init()
    }

    init () {
      this.swiper = new Swiper(this, this.options)
    }
  }

  window.customElements.define('featured-links', FeaturedLinks);
}